import { cn } from "@/lib/utils";
import type { FlaskConical, Database } from "lucide-react";
import type { FeatureCategory, FeatureCategoryKey } from "./types";
import { TruncatedText } from "@/components/ui/truncated-text";

type NavItemProps = {
  category: FeatureCategory | { key: "payload-library"; label: string; icon: typeof Database | typeof FlaskConical };
  active: boolean;
  onSelect: (k: FeatureCategoryKey) => void;
};

export function NavItem({ category, active, onSelect }: NavItemProps) {
  const Icon = category.icon;
  return (
    <button
      type="button"
      onClick={() => onSelect(category.key)}
      aria-current={active ? "page" : undefined}
      className={cn(
        "w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm text-left transition-colors",
        active
          ? "bg-primary-tint-soft text-foreground font-semibold"
          : "text-muted-foreground hover:bg-muted/50 hover:text-foreground"
      )}
    >
      <Icon className={cn("h-4 w-4 shrink-0", active ? "text-primary" : "text-muted-foreground")} />
      <TruncatedText>{category.label}</TruncatedText>
    </button>
  );
}
